// extracted by mini-css-extract-plugin
export default {"brandPromo":"ZH-z","carousel":"_H-z"};